"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
}); //# sourceMappingURL=CustomErrorOptions.js.map
